import { useEffect } from "react";
import React, { createContext, useContext, useMemo, useState } from 'react';


import { TabPanel, TabView } from "primereact/tabview";
import "./StudiesInform.scss";
import PendingView from "./tabs/PendingTab/PendingView";
import CancelledView from "./tabs/CancelledTab/CancelledView";
import FinishedView from "./tabs/FinishedTab/FinishedView";
import useResizeListener from "../../hooks/useResizeListener";
import MobileTabSelector, { MobileTabSelectorOption } from "./components/MobileTabSelector";

//TODO: Pasar esto a constantes 
export const StudiesInformConfigTab = {
    PENDIENTES: { id: 0, name: "Pendientes" },
    INFORMADOS: { id: 1, name: "Informados" },
    CANCELADOS: { id: 2, name: "Cancelados" },
};

//TODO: Pasar esto a constantes
const StudiesInformTabOptions = [
    StudiesInformConfigTab.PENDIENTES,
    StudiesInformConfigTab.INFORMADOS,
    StudiesInformConfigTab.CANCELADOS,
];

const StudiesInformMobileTabOptions: MobileTabSelectorOption[] = StudiesInformTabOptions.map((tab) => ({
    id: tab.id,
    label: tab.name,
}));

export default function StudiesInform() {

    const isMobile = useResizeListener(768);

    const settings = JSON.parse(localStorage.getItem("settings") ?? "{}");
    const profileName: string | undefined = settings?.loginResponse?.user?.profile?.name;
    const isExternalProfessional = profileName === "Profesional externo";

    const [activeTab, setActiveTab] = useState(0); //useStudiesInformConfigContext();

    if (isExternalProfessional) {
        return (
            <div className="studies-inform-config-view viewContainer bg-white pd-4">
                <div className="header-row">
                    <h1 className="title mt-2">Informe de estudios</h1>
                </div>

                <div className="studies-inform-tab-content">
                    <FinishedView onlyOwnProfessional />
                </div>
            </div>
        );
    }

    return (
        <div className="studies-inform-config-view viewContainer bg-white pd-4">
            <div className="header-row">
                <h1 className="title mt-2">Informe de estudios</h1>
                {isMobile ? (
                    <MobileTabSelector
                        id="studiesinformtabselectorid"
                        className="studies-inform-mobile-tab-selector"
                        value={activeTab}
                        options={StudiesInformMobileTabOptions}
                        onChange={(id) => setActiveTab(Number(id))}
                        ariaLabel="Seleccionar tab de informes"
                    />
                ) : (
                    <TabView
                        id="tabcontainer"
                        className="tab-component overflow-x-auto"
                        activeIndex={activeTab}
                        onTabChange={(e) => setActiveTab(e.index)}
                    >
                        <TabPanel key={"tabpendings"} header={StudiesInformConfigTab.PENDIENTES.name} />
                        <TabPanel key={"tabfinished"} header={StudiesInformConfigTab.INFORMADOS.name} />
                        <TabPanel key={"tabcancelled"} header={StudiesInformConfigTab.CANCELADOS.name} />
                    </TabView>
                )}
            </div>

            <div className="studies-inform-tab-content">
                {activeTab === StudiesInformConfigTab.PENDIENTES.id && <PendingView />}
                {activeTab === StudiesInformConfigTab.INFORMADOS.id && <FinishedView />}
                {activeTab === StudiesInformConfigTab.CANCELADOS.id && <CancelledView />}
            </div>
        </div>
    );
}


